import { render, staticRenderFns } from "./GoTop.vue?vue&type=template&id=3a9cb37e&"
import script from "./GoTop.vue?vue&type=script&lang=ts&"
export * from "./GoTop.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports